<template>
  <div class="performance-page">
    <PerformanceComingSoonPage v-if="catalogEnabled === false" />
    <template v-else-if="catalogEnabled">
      <PageTitle title="Performance" />
      <PerformanceMenu :items="menuItems" :value="selectedTab" @onChange="selectedTab = $event" />
      <KPIsCatalog v-if="selectedTab === KPIS_TAB_INDEX" />
    </template>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import PageTitle from "@components/common/PageTitle.vue";
import PerformanceMenu from "@components/PerformanceMenu/PerformanceMenu.vue";
import { LD_FLAG_IDEA_MDP_428 } from "@components/constants/launchDarklyFlagKeys";
import PerformanceComingSoonPage from "@/views/PerformanceComingSoonPage/PerformanceComingSoonPage.vue";
import KPIsCatalog from "@/views/Performance/KPIsCatalog.vue";

const { proxy } = getCurrentInstance();

// Scorecards and Periods have no pages yet, so KPIs is the only tab.
const KPIS_TAB_INDEX = 0;
const menuItems = [{ title: "KPIs", count: null }];
const selectedTab = ref(KPIS_TAB_INDEX);
const catalogEnabled = ref(null);

onMounted(async () => {
  try {
    catalogEnabled.value = (await proxy.$getFlag(LD_FLAG_IDEA_MDP_428, false)) === true;
  } catch {
    catalogEnabled.value = false;
  }
});
</script>

<style scoped>
.performance-page {
  width: 100%;
}
</style>
